// @ts-expect-error Untyped
import RequestStatus from 'developer-docs-shared-components/lib/models/RequestStatus';
export const selectGetAllSpecsStatus = state => state.allSpecsState.status;
export const selectSpecInfo = (group, name) => state => {
  var _state$allSpecsState$;
  if (!group || !name || state.allSpecsState.status !== RequestStatus.succeeded) {
    return null;
  }
  return ((_state$allSpecsState$ = state.allSpecsState.specs) === null || _state$allSpecsState$ === void 0 || (_state$allSpecsState$ = _state$allSpecsState$[group]) === null || _state$allSpecsState$ === void 0 ? void 0 : _state$allSpecsState$[name]) || null;
};